import { type SetStoreState, createStore } from '@seeqdev/utils';
import type { CaptureOutputV1 } from '@seeqdev/api/model/CaptureOutputV1';

export interface CapturesState {
  /** The capture the dialog is open on. */
  openCapture?: CaptureOutputV1;
}

export interface CapturesActions {
  openCaptureDialog: (capture: CaptureOutputV1) => void;
  closeCaptureDialog: () => void;
}

const initialState: CapturesState = {
  openCapture: undefined,
};

const capturesActionsFactory = (set: SetStoreState<CapturesState>): CapturesActions => ({
  openCaptureDialog: (capture) =>
    set((draft: CapturesState) => {
      draft.openCapture = capture;
    }),

  closeCaptureDialog: () =>
    set((draft: CapturesState) => {
      draft.openCapture = undefined;
    }),
});

const [CapturesStoreProvider, useCapturesStoreInstance, useCapturesSelector] = createStore(
  'Captures',
  initialState,
  capturesActionsFactory,
);

export { CapturesStoreProvider };

export const useOpenCapture = () => useCapturesSelector((state) => state.openCapture);
export const useCapturesActions = () => useCapturesStoreInstance().actions;
